import React, { Component } from "react";
import Button from "@material-ui/core/Button";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { APPNAME } from "../components/Constants";
import { withTranslation } from "react-i18next";
class SsoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      returnUrl: "",
    };
  }

  componentDidMount() {
    let currentLocation = window.location.href;
    let tokenParam = "?token=";
    let n = currentLocation.indexOf(tokenParam);
    let tokenValue = currentLocation.substring(n + tokenParam.length);
    fetch("on_sso_login", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        token: tokenValue,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.error) {
          this.setState({ errorString: reply.errorString });
          if (reply.returnUrl.length > 0) {
            this.setState({ returnUrl: reply.returnUrl });
          }
        } else {
          if (reply.returnUrl.length > 0) {
            window.sco_return_url = reply.returnUrl;
          }
          this.props.history.push({
            pathname: "/enter",
            state: {
              secureToken: reply.secureToken,
              lastLogin: reply.lastLogin,
              isReadOnly: false,
            },
          });
        }
      })
      .catch((error) => {
        this.setState({
          errorString: "The server responded with a status of " + error.message,
        });
      });
  }

  handleBack(e) {
    window.location.href = this.state.returnUrl;
    this.setState({ returnUrl: "" });
  }

  render() {
    let { t } = this.props;
    return (
      <div>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" color="inherit">
              {APPNAME}
            </Typography>
          </Toolbar>
        </AppBar>

        {this.state.errorString.length > 0 && (
          <div>
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
            &nbsp;&nbsp;
            {this.state.returnUrl.length > 0 && (
              <Button
                variant="outlined"
                color="primary"
                onClick={(event) => this.handleBack(event)}
              >
                {t("goBack.button")}
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(SsoPage);
